import { render, staticRenderFns } from "./ReAccreditationCallback.vue?vue&type=template&id=75983628&scoped=true&"
import script from "./ReAccreditationCallback.vue?vue&type=script&lang=js&"
export * from "./ReAccreditationCallback.vue?vue&type=script&lang=js&"
import style0 from "./ReAccreditationCallback.vue?vue&type=style&index=0&id=75983628&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75983628",
  null
  
)

export default component.exports